import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const PartnerRegistration = lazy(() => import('../pages/partner-registration/page'));
const DentalCare = lazy(() => import('../pages/services/dental-care/page'));
const Treatments = lazy(() => import('../pages/treatments/page'));
const BookTreatment = lazy(() => import('../pages/book-treatment/page'));
const About = lazy(() => import('../pages/about/page'));
const HowItWorks = lazy(() => import('../pages/how-it-works/page'));
const Supervision = lazy(() => import('../pages/supervision/page'));
const Faq = lazy(() => import('../pages/faq/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/partner-registration',
    element: <PartnerRegistration />,
  },
  {
    path: '/services/dental-care',
    element: <DentalCare />,
  },
  {
    path: '/treatments',
    element: <Treatments />,
  },
  {
    path: '/book-treatment',
    element: <BookTreatment />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/how-it-works',
    element: <HowItWorks />,
  },
  {
    path: '/supervision',
    element: <Supervision />,
  },
  {
    path: '/faq',
    element: <Faq />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
